import { Check } from 'lucide-react';

const steps = [
  { id: 1, name: 'Job Description', description: 'Paste the job posting' },
  { id: 2, name: 'Upload Resume', description: 'Upload your PDF resume' },
  { id: 3, name: 'Optimize', description: 'AI enhances your resume' },
  { id: 4, name: 'Results', description: 'Download optimized resume' },
];

const StepWizard = ({ currentStep }) => {
  return (
    <div className="w-full max-w-3xl mx-auto mb-8" data-testid="step-wizard">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <div key={step.id} className="flex items-center flex-1">
            <div className="flex flex-col items-center">
              <div
                className={`
                  w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm
                  transition-all duration-300
                  ${currentStep > step.id 
                    ? 'bg-green-500 text-white' 
                    : currentStep === step.id 
                      ? 'bg-accent text-white ring-4 ring-accent/20' 
                      : 'bg-slate-100 text-slate-400 border border-slate-200'
                  }
                `}
                data-testid={`step-${step.id}`}
              >
                {currentStep > step.id ? (
                  <Check className="h-5 w-5" />
                ) : (
                  step.id
                )}
              </div>
              <div className="mt-2 text-center hidden sm:block">
                <p className={`text-sm font-medium ${
                  currentStep >= step.id ? 'text-slate-900' : 'text-slate-400'
                }`}>
                  {step.name}
                </p>
                <p className="text-xs text-slate-500 mt-0.5 max-w-[120px]">
                  {step.description}
                </p>
              </div>
            </div>
            {index < steps.length - 1 && (
              <div 
                className={`
                  flex-1 h-0.5 mx-2 sm:mx-4 mt-[-24px] sm:mt-0
                  ${currentStep > step.id ? 'bg-green-500' : 'bg-slate-200'}
                `}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepWizard;
